import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { useI18N } from "@sundae/react-hooks";
import { Text, toolkitCx } from "@sundae/ui-toolkit";
import cx from "classnames";
import { FC, useCallback } from "react";

import { testIds } from "../../constants/testIds.constants";
import { Actions, useAppContext } from "../../stores";
import PoolComponent from "../PoolComponent";

const PoolSelectBox: FC = () => {
  const { t } = useI18N("liquidity");
  const {
    dispatch,
    state: { activeZapPool },
  } = useAppContext();

  const handlePoolSelectOpen = useCallback(() => {
    Actions.setDialogState({ dialog: "liquidity.zapPoolSelect", isOpen: true }, dispatch);
  }, [dispatch]);

  return (
    <>
      <div
        data-testid={testIds.zapDialog.poolSelect.content}
        className={cx(
          "grid items-start gap-2",
          toolkitCx.layout.transition.colors,
          toolkitCx.layout.border.hoverable
        )}
      >
        <div
          className={cx(
            "flex h-full w-full cursor-pointer select-none items-center gap-2 rounded-lg",
            toolkitCx.layout.background.hoverable,
            toolkitCx.layout.shadow.default,
            toolkitCx.layout.transition.colors,
            toolkitCx.layout.border.default,
            toolkitCx.layout.border.weight.default,
            toolkitCx.layout.spacing.both.md,
            toolkitCx.layout.spacing.right.lg
          )}
          onClick={handlePoolSelectOpen}
        >
          {activeZapPool ? (
            <PoolComponent pool={activeZapPool} />
          ) : (
            <Text className="uppercase" size="sm" weight="semibold" tag="span">
              {t("zap.selectPool")}
            </Text>
          )}
          <ChevronDownIcon className={cx("ml-auto h-5 w-5", toolkitCx.layout.text.default)} />
        </div>
      </div>
    </>
  );
};

export default PoolSelectBox;
